import { isArrayBuffer as isArrayBuffer$1 } from '../../predicate/isArrayBuffer.mjs';

function isArrayBuffer(value) {
    return isArrayBuffer$1(value);
}

export { isArrayBuffer };
